import { Field, FieldProps, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import * as React from 'react'
import { IAssistanceObject } from '../../../types'
import { isNotBlank } from '../../../utils/validators'
import ErrorMessage from '../../ui/ErrorMessage'
import Dropdown from './Dropdown'

export interface IFormValues {
  categories: ICategory[]
  categoryId: string
  instruction: string
  type: string
  formError?: string
}

interface ICategory {
  label: string
  value: string
}

interface IFormProps {
  onCancelClick: () => void
  categories: ICategory[]
}

interface IAddAssistanceCreateFormProps {
  categories: ICategory[]
  onCancelClick: () => void
  onCreateClick: (assistance: IAssistanceObject) => Promise<any>
}

export const InnerForm = (props: IFormProps & FormikProps<IFormValues>): any => {
  const { touched, errors, isSubmitting, onCancelClick, handleSubmit, categories } = props

  const textInput = ({ field, form }: FieldProps<IFormValues>) => {
    return <input type='text' {...field} />
  }

  const textAreaInput = ({ field, form }: FieldProps<IFormValues>) => {
    return <textarea rows={4} cols={50} style={{ resize: 'none' }} {...field} />
  }
  const defaultOption = categories[0]

  return (
    <Form onSubmit={handleSubmit}>
      <ErrorMessage visible={!!errors.formError} className='mt1'>
        Failed to create Mobility Device
      </ErrorMessage>

      {/* Category */}
      <div className='mt1'>
        <label className='font-small weight-300 font-grey3'>Category</label>
        <Dropdown name='category' options={categories} defaultOption={defaultOption} placeholder='Select Category' />
      </div>

      {/* Name */}
      <div className='mt2'>
        <label className='font-small weight-300 font-grey3'>Type*</label>
        <Field name='type' render={textInput} />
        {touched.type && errors.type && (
          <span className='ErrorMsgDivForType font-small weight-300 font-red'>{errors.type}</span>
        )}
      </div>

      {/* Instruction */}
      <div className='mt2'>
        <label className='font-small weight-300 font-grey3'>Instruction*</label>
        <Field name='instruction' render={textAreaInput} />
        {touched.instruction && errors.instruction && (
          <span className='ErrorMsgDivForInstruction font-small weight-300 font-red'>{errors.instruction}</span>
        )}
      </div>

      {/* Buttons */}
      <div className='flex items-center justify-end mt3'>
        <button type='button' onClick={onCancelClick} className='CancelButton btn bg-white rounded font-light-grey mr2'>
          Cancel
        </button>

        <button
          type='submit'
          disabled={isSubmitting}
          className='SubmitButton btn bg-green rounded font-white weight-300'
        >
          Add
        </button>
      </div>
    </Form>
  )
}

export const AddAssistanceCreateForm = withFormik<IAddAssistanceCreateFormProps, IFormValues>({
  mapPropsToValues: (props: IAddAssistanceCreateFormProps): IFormValues => {
    return {
      categoryId: props.categories[0].value,
      type: '',
      instruction: '',
      categories: props.categories
    }
  },
  mapValuesToPayload: x => x,
  validate: (values: IFormValues): FormikErrors<IFormValues> => {
    const errors: FormikErrors<IFormValues> = {}
    if (!isNotBlank(values.type)) {
      errors.type = 'Type is required'
    }
    if (!isNotBlank(values.instruction)) {
      errors.instruction = 'Instruction is required'
    }
    return errors
  },
  handleSubmit: (values: IFormValues, { props, setSubmitting, setFieldError }) => {
    props
      .onCreateClick({
        id: '0',
        instruction: values.instruction,
        categoryId: values.categoryId,
        type: values.type
      })
      .then(result => {
        setSubmitting(false)
        props.onCancelClick()
      })
      .catch((error: string) => {
        setFieldError('formError', error)
        setSubmitting(false)
      })
  }
})(InnerForm)

export default AddAssistanceCreateForm



// WEBPACK FOOTER //
// ./src/components/assistance/AddAsistanceForm/AddAssistanceCreateForm.tsx